import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22theme.js%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./ff-cocon-pro.woff2%22,%22display%22:%22swap%22,%22preload%22:false,%22fallback%22:[%22ui-sans-serif%22,%22system-ui%22,%22Segoe%20UI%22,%22Trebuchet%20MS%22,%22Helvetica%20Neue%22,%22Helvetica%22,%22Arial%22,%22Noto%20Sans%22,%22Liberation%20Sans%22,%22sans-serif%22]}],%22variableName%22:%22FF_COCON%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'FF_COCON', 'FF_COCON Fallback', ui-sans-serif, system-ui, Segoe UI, Trebuchet MS, Helvetica Neue, Helvetica, Arial, Noto Sans, Liberation Sans, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
